import React from 'react';
import { Button, Icon, Row, Table, Form, Select, Spin } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
// import { Link } from 'dva/router';
import styles from './../styles.less';

const FormItem = Form.Item;

class BranchesReplace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.bid,
      targetGroups: [],
    };
  }

  componentDidMount() {
    this.loadRelatedTargetGroups(this.state.id);
    if (!this.props.branches.branchesList.length) {
      this.props.dispatch({ type: 'branches/loadList' });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.bid && this.state.id && nextProps.bid !== this.state.id) {
      this.loadRelatedTargetGroups(nextProps.bid);
    }
  }

  loadRelatedTargetGroups(id) {
    this.setState({ id });
    this.props.dispatch({
      type: 'targetGroups/loadListForBranch',
      payload: { id },
    }).then((targetGroups) => {
      this.setState({ targetGroups });
    });
  }

  render() {
    const { Column } = Table;
    const { getFieldDecorator } = this.props.form;
    const bid = Number(this.props.bid);
    const branchesExcludingCurrent = this.props.branches.branchesList.filter(i => i.id !== bid);
    const Option = Select.Option;

    return (
      <div className={styles.modalWithReplacingBranches}>
        <h3 className={styles.warning}><FormattedMessage id="Common.Attention" /></h3>
        <p className={styles.warning}>
          <FormattedMessage id="Component.Branches.Replace.Warning.Text" values={{ targetGroupsCount: this.state.targetGroups.length }} />
        </p>
        <p className="bold">Option 1:</p>
        <p><FormattedMessage id="Component.Branches.Replace.Option1.Text" /></p>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.props.handleReplaceBranch(this.props.form);
          }}
          className={styles.replaceForm}
        >
          <Row type="flex" align="center">
            <FormItem>
              {getFieldDecorator('replace_to', {
                rules: [{
                  required: true,
                  message: this.props.intl.formatMessage({ id: 'Common.Field.Required' }),
                }],
              })(
                <Select style={{ width: '75%' }}>
                  {branchesExcludingCurrent.map(
                    b => <Option key={b.id} value={b.id}>{b.name}</Option>,
                  )}
                </Select>,
              )}
            </FormItem>
          </Row>
          <Row type="flex" align="center">
            <Button type="primary" htmlType="submit">
              <FormattedMessage id={'Component.Branches.Replace'} />
            </Button>
          </Row>
        </Form>

        <hr />

        <p><FormattedMessage id="Component.Branches.Replace.Option" /> 2:</p>
        <p><FormattedMessage id="Component.Branches.Replace.Option2.Text" /></p>

        <Spin spinning={!!this.props.loading.models.targetGroups}>
          <Table
            dataSource={this.state.targetGroups}
            pagination={false}
            bordered
            rowKey="tg-id"
            showHeader={false}
            scroll={{ y: 150 }}
            size="small"
          >
            <Column
              title="Target group"
              dataIndex="name"
              key="name"
            />
            <Column
              title=""
              key="edit"
              render={tg => (
                <span>
                  <a target="_blank" rel="noopener noreferrer" href={`/${tg.project_id}/target-groups/${tg.id}/edit/`}><Icon type="edit" /></a>
                </span>
              )}
            />
          </Table>
        </Spin>

        <p><FormattedMessage id="Component.Branches.Replace.Confirm.Text" /></p>

      </div>
    );
  }
}


export default connect(({ app, targetGroups, branches, loading }) =>
  ({ app, targetGroups, branches, loading }))(Form.create()(injectIntl(BranchesReplace)));



// WEBPACK FOOTER //
// ./src/components/Branches/BranchesReplace/BranchReplace.js